import { Box, Grid } from '@mui/material';
import { useEffect, } from 'react';
import { colors } from 'styles/colors';
import CustomText from 'components/common/CustomText/CustomText';
import { hexWithOpacity } from 'common/utils';
import RegistryUserItem from '../RegistryUserItem/RegistryUserItem';
import { useGetRegistryUsers } from 'hooks/useRegistryUsers';
import { useParams } from 'react-router-dom';
import { ERegistryStatus } from 'enum/ERegistryStatus';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';

export default function RegistryCollaboratorsUsers() {
  const registryId = Number(useParams().registryId);

  const {
    data: users = [],
    isLoading,
    refetch,
  } = useGetRegistryUsers(
    {
      registryId,
      status: ERegistryStatus.ACCEPTED,
    },
    {
      enabled: !!registryId,
      refetchOnWindowFocus: false,
      select: (res: any) => {
        return res.data;
      }
    }
  );

  useEffect(() => {
    if (users) {
      console.log('last users', users);
    }
  }, [users])

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        spacing={1.5}
        p={2}
        sx={{
          flexGrow: isLoading || users.length > 0 ? 0 : 1,
          display: 'flex',
        }}
      >
        {isLoading ? (
          Array.from({ length: 6 }).map((_, index) => (
            <Grid key={index} size={{ xs: 12, lg: 6, xl: 4 }}>
              {/* <ExportedItemSkeleton /> */}
            </Grid>
          ))
        ) : users.length > 0 ? (
          users.map((item: any, index: number) => (
            <Grid key={`${item.user.id}-${index}`} size={{ xs: 12, lg: 6, xl: 4 }}>
              <RegistryUserItem item={item} refetch={refetch} />
            </Grid>
          ))
        ) : (
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              textAlign="center"
              gap={2}
            >
              <Box height={100}>
                <GroupOutlinedIcon sx={{ fontSize: 100, color: hexWithOpacity(colors.secondary, 0.5) }} />
              </Box>
              <CustomText
                text='No collaborators yet'
                color={colors.secondary}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
